module.exports = __webpack_public_path__ + "static/img/sort2.1158985e.png";